export default function NotFound() {
    return (
        <div className="flex items-center justify-center min-h-[50vh] text-gray-500">
            Page introuvable
        </div>
    )
}
